<template>
  <Transition name="slide-fade" appear>
    <div v-if="visible" class="modal-end">
      <div class="modal-content">
        <div class="modal-header">
          <span class="modal-header-txt" v-if="!editMode">{{$t('add_a_new_company')}}</span>
          <span class="modal-header-txt" v-else>{{$t('edit_company')}}</span>
        </div>
        <div class="upload-image-main-div">
          <div class="upload-image-div">
            <span class="header-span">{{$t('image')}}</span>
            <div class="upload-image-div">
              <span class="upload-image-txt">{{$t('profile_photo_explanation')}}</span>
              <span class="upload-image-txt">{{$t('recommended_format')}}</span>
            </div>
          </div>
          <FileDrop :selected-file="editData.logoUrl" :on-file-selected="onFileSelect"/>
        </div>
        <div class="forms">
          <div class="double-form">
            <div class="form-div">
              <span class="form-title">{{$t('company_name')}} <span class="required-star">*</span></span>
              <input class="form-input" :class="{'input-error': errors.name}" :placeholder="this.$t('enter_company_name')" v-model="companyData.name"  />
              <span v-if="errors.name" class="error-text">{{ errors.name }}</span>
            </div>
            <div class="form-div">
              <span class="form-title">{{$t('authorized')}} <span class="required-star">*</span></span>
              <input class="form-input" :class="{'input-error': errors.authorized}" :placeholder="this.$t('name_surname_content')" v-model="companyData.authorized" />
              <span v-if="errors.authorized" class="error-text">{{ errors.authorized }}</span>
            </div>

          </div>
          <div class="double-form">
            <div class="form-div">
              <span class="form-title">{{$t('work_phone')}}</span>
              <input
                  class="form-input"
                  :placeholder="this.$t('enter_work_phone_number')"
                  v-model="companyData.phone"
                  @keypress="preventNonNumeric"
                  type="tel"
              />
            </div>
            <div class="form-div">
              <span class="form-title">{{$t('mobile_phone_number')}}</span>
              <PhoneInput v-model="this.companyData.mobilePhone"/>
            </div>
          </div>
          <div class="double-form">
            <div class="form-div">
              <span class="form-title">{{$t('e_mail')}} <span class="required-star">*</span></span>
              <input class="form-input" :class="{'input-error': errors.email}" :placeholder="this.$t('enter_mail')" v-model="companyData.email"/>
              <span v-if="errors.email" class="error-text">{{ errors.email }}</span>
            </div>
          </div>

          <div class="double-form">
            <div class="form-div">
              <span class="form-title">{{$t('tax_number')}}</span>
              <input class="form-input" :placeholder="this.$t('tax_number')" v-model="companyData.taxNumber" />
            </div>
          </div>
          <div class="double-form">
            <div class="form-div">
              <span class="form-title">{{$t('tax_office')}}</span>
              <input class="form-input" :placeholder="this.$t('tax_office')" v-model="companyData.taxOffice" />
            </div>
          </div>

          <div class="double-form">
            <div class="form-div">
              <span class="form-title">{{$t('address_person')}}</span>
              <input class="form-input" :placeholder="this.$t('enter_address')" v-model="companyData.address" />
            </div>
          </div>
          <div class="double-form">
            <div class="form-div">
              <span class="form-title">{{$t('sector')}}</span>
              <div class="dropdown" @click="toggleSectorDropdown" v-click-outside="hideSectorDropdown">
                <span v-if="!companyData.sector?.sectorName">{{this.showSectorText}}</span>
                <span v-else>{{companyData.sector?.sectorName}}</span>
                <img src="@/assets/images/arrowdown.svg" />
                <div class="dropdown-content" v-if="sectorDropdown">
                  <div class="list scroll-design">
                    <div class="item" v-for="sector in sectorList" :key="sector.id" @click="selectSector(sector)">
                      <span>{{ sector.name }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="btn-div" @click="onCompanyAction">
          <div class="btn-style" @close="addCompany">
            <span class="next-txt" v-if="!loading && !editMode">{{$t('add_company')}}</span>
            <span class="next-txt" v-if="!loading && editMode">{{$t('save_button')}}</span>
            <VueSpinnerIos v-if="loading" size="20" height="100%" color="#fff" />
          </div>
        </div>
        <div @click="this.onHide" class="close-btn">
          <img class="cross" src="../../assets/images/cross.svg" />
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
import TextInput from "@/components/TextInput.vue";
import SelectBox from "@/components/SelectBox.vue";
import SuccessModal from "@/components/modals/SuccessModal.vue";
import FileDrop from "@/components/FileDrop.vue";
import {
  VueSpinnerIos
} from 'vue3-spinners';
import companyService from "@/service/companyService";
import {handleErrorResponse} from "@/utils/utils";
import PhoneInput from "@/components/PhoneInput.vue";
import commonService from "@/service/commonService";

export default {
  components: {
    PhoneInput,
    FileDrop,
    SuccessModal,
    TextInput,
    SelectBox,
    VueSpinnerIos
  },
  props: {
    editMode: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: {
        name: '',
        phone: '',
        mobilePhone: '',
        address: '',
        taxNumber: '',
        taxOffice: '',
        authorized: '',
        email: '',
      }
    },
    visible: {
      type: Boolean,
      default: false
    },
    onHide: {
      type: Function,
      default: () => {}
    },
    refreshCallback: {
      type: Function,
      default: () => {}
    },
  },
  data() {
    return {
      showSectorText:this.$t("select_sector"),
      companyData: {
        name: '',
        phone: '',
        mobilePhone: '',
        address: '',
        authorized: '',
        email: '',
        taxNumber: '',
        taxOffice: '',
        addCompany:true,
        sector:{
          sectorName:"",
          sectorId:""
        }
      },
      sectorList:[],
      sectorDropdown:false,
      uploadFile: null,
      loading: false,
      errors: {},
    };
  },
  watch: {
    visible: {
      handler(newVal) {
        if (newVal && this.editMode) {
          this.companyData = {
            companyId: this.editData.companyId,
            name: this.editData.name,
            phone: this.editData.phone,
            mobilePhone: this.editData.mobilePhone,
            address: this.editData.address,
            authorized: this.editData.authorizedName,
            email: this.editData.authorizedemail,
            taxNumber: this.editData.taxNumber || '',
            taxOffice: this.editData.taxOffice || '',
            addCompany: true,
            sector: {
              sectorName: this.editData.sector?.sectorName || '',
              sectorId: this.editData.sector?.sectorId || ''
            }
          };

          if (this.editData.sector?.sectorName) {
            this.showSectorText = this.editData.sector.sectorName;
          }
        } else if (!newVal) {
          this.resetForm();
        }
      },
      immediate: true
    }
  },

  created() {
    commonService.getSectors().then(response => {
      this.sectorList=response.data.data.sector;
    })
  },
  methods: {
    resetForm() {
      this.companyData = {
        name: '',
        phone: '',
        mobilePhone: '',
        address: '',
        authorized: '',
        email: '',
        taxNumber: '',
        taxOffice: '',
        addCompany: true,
        sector: {
          sectorName: "",
          sectorId: ""
        }
      };
      this.showSectorText = this.$t("select_sector");
      this.uploadFile = null;
      this.errors = {};
    },

    onCompanyAction() {
      if (!this.validateForm()) return;

      if (this.editMode) {
        this.onEditCompany();
      } else {
        this.onSaveCompany();
      }
    },

    validateForm() {
      this.errors = {};
      let isValid = true;

      if (!this.companyData.name?.trim()) {
        this.errors.name = this.$t('company_name_required');
        isValid = false;
      }
      if (!this.companyData.authorized?.trim()) {
        this.errors.authorized = this.$t('authorized_required');
        isValid = false;
      }
      if (!this.companyData.email?.trim()) {
        this.errors.email = this.$t('email_required');
        isValid = false;
      } else {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(this.companyData.email)) {
          this.errors.email = this.$t('valid_email_required');
          isValid = false;
        }
      }
      if (!isValid) {
        this.$snackbar.add({ type: 'warning', text: this.$t('required_fields_warning') });
      }

      return isValid;
    },

    preventNonNumeric(e) {
      if (!/[0-9]/.test(e.key)) {
        e.preventDefault();
      }
    },

    toggleSectorDropdown() {
      this.sectorDropdown = !this.sectorDropdown;
    },

    hideSectorDropdown() {
      this.sectorDropdown = false;
    },

    selectSector(sector) {
      this.companyData.sector = {
        sectorName: sector.name,
        sectorId: sector.id
      };
      this.showSectorText = sector.name;
      this.sectorDropdown = false;
    },

    onSaveCompany() {
      this.loading = true;
      const formData = new FormData();

      Object.entries(this.companyData).forEach(([key, value]) => {
        if (key !== 'sector') {
          formData.append(key, value);
        }
      });

      if (this.companyData.sector?.sectorId) {
        formData.append('sectorId', this.companyData.sector.sectorId);
      }

      if (this.uploadFile) {
        formData.append('logo', this.uploadFile);
      }

      companyService.addCompany(formData).then(response => {
        this.loading = false;
        this.$snackbar.add({
          type: 'success',
          text: this.$t('company_added_successfully')
        });
        this.onHide();
        this.refreshCallback();
      }).catch(error => {
        this.loading = false;
        handleErrorResponse(error, this.$snackbar);
      });
    },

    onEditCompany() {
      this.loading = true;

      const formData = new FormData();

      Object.entries(this.companyData).forEach(([key, value]) => {
        if (key !== 'sector') {
          formData.append(key, value);
        }
      });

      if (this.companyData.sector?.sectorId) {
        formData.append('sectorId', this.companyData.sector.sectorId);
      }

      if (this.uploadFile) {
        formData.append('logo', this.uploadFile);
      }

      companyService.updateCompany(formData).then(response => {
        this.loading = false;
        this.$snackbar.add({
          type: 'success',
          text: this.$t('company_updated_successfully')
        });
        this.onHide();
        this.refreshCallback();
      }).catch(error => {
        this.loading = false;
        handleErrorResponse(error, this.$snackbar);
      });
    },

    onFileSelect(file) {
      this.uploadFile = file;
    },
  },
};
</script>

<style scoped>

.modal-content {
  position: relative;
  background-color: white;
  width: 50%;
  height: 100%;
  border-radius: 12px;
  padding: 24px;
  overflow-y: auto;
  max-height: calc(100vh - 48px);
}

.modal-content::-webkit-scrollbar {
  width: 15px;
}

.modal-content::-webkit-scrollbar-track {
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
  background-color: #FFF;
}

.modal-content::-webkit-scrollbar-thumb {
  background-color: rgba(4, 12, 45, 0.2);
  border-radius: 10px;
  border: 5px transparent solid;
  background-clip: padding-box;
}

.modal-content::-webkit-scrollbar-thumb:hover {
  background-color: rgba(4, 12, 45, 0.4);
}

.close-btn {
  position: absolute;
  top: 24px;
  right: 24px;
  background: none;
  border: none;
  cursor: pointer;
  background-color: #F2F4F7;
  border-radius: 3000px;
}
.cross{
  padding: 8px;
}
.modal-header{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 10px 0 10px 0;
  border: none;
}
.modal-header-txt{
  font-family: euclid_semi_bold, sans-serif;
  color: #040C2D;
  font-size: 18px;
  font-style: normal;
  line-height: 24px;
}
.upload-image-main-div{
  display: flex;
  flex-direction: row;
  gap: 40px;
  margin-top: 24px;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
  width: 100%;
  height: auto;
}
.upload-image-div{
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
  width: 100%;
}
.header-span{
  font-family: euclid_semi_bold, sans-serif;
  color: #040C2D;
  font-size: 16px;
  line-height: 24px;
}
.upload-image-txt{
  color: #667085;
  font-size: 14px;
  line-height: 20px;
}
.forms{
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 24px;
  align-items: flex-start;
  width: 100%;
}
.double-form{
  display: flex;
  flex-direction: row;
  gap: 24px;
  align-items: flex-start;
  width: 100%;
}
.form-div{
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
  width: 100%;
}
.form-title{
  color: #010511;
  font-size: 14px;
  font-style: normal;
  line-height: 20px;
}
.btn-style{
  display: flex;
  border-radius: 24px;
  background: #040C2D;
  justify-content: center;
  align-items: center;
  width: 20%;
  height: 48px;
  cursor: pointer;
}
.next-txt{
  font-family: euclid_medium, sans-serif;
  color: #FFF;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  line-height: 20px;
}
.btn-div{
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  margin-top: 20px;
}

/* Dropdown styles */
.dropdown {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  background-color: #F5F5F5;
  border-radius: 8px;
  cursor: pointer;
}

.dropdown-content {
  position: absolute;
  top: 60px;
  left: 0;
  width: 100%;
  background-color: #FFFFFF;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  border-radius: 16px;
  padding: 10px;
  z-index: 999;
}

.list {
  display: flex;
  flex-direction: column;
  gap: 5px;
  max-height: 200px;
  overflow-y: auto;
}

.item {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  cursor: pointer;
  font-family: euclid_medium, sans-serif;
  font-size: 12px;
  color: #000000;
  padding: 10px;
}

.item:hover {
  background-color: #F5F5F5;
}

.required-star {
  color: #F04438;
  font-weight: bold;
}

.error-text {
  color: #F04438;
  font-size: 12px;
  font-family: euclid_regular, sans-serif;
  margin-top: 4px;
}

.input-error {
  border: 1px solid #F04438 !important;
}

@media (max-width: 678px) {
  .upload-image-main-div {
    flex-direction: column;
    gap: 10px;
  }
}
</style>
